import load from "@src/layout/modules_load";
import { id } from "./power";

export default {
    [id.id]: {
        component: load(() => import("./index")),
        name: id.name,
        id: id
    }
};
